import { __ } from "@wordpress/i18n";
import React, { createContext, useContext, useState } from "react";
import Restrictions from "../assets/images/Restrictions.svg";
import Security from "../assets/images/Security.svg";
import Login from "../assets/images/Login.svg";
import More from "../assets/images/More.svg";
import Subscriptions from "../assets/images/Subscriptions.svg";
import Feedback from "../assets/images/Feedback.svg";
import Review from "../assets/images/Review.svg";
import SupportCenter from "../assets/images/SupportCenter.svg";
import OtherPlugin from "../assets/images/OtherPlugin.svg";

const MenuContext = createContext();

const menuData = [
	{
		title: __("Login", "ultimate-security"),
		url: "/login",
		icon: Login,
		page: {
			title: __("Login", "ultimate-security"),
			description: "",
		},
		sub: [
			{
				title: __("Temporary Login", "ultimate-security"),
				url: "/login/temporary-login",
				page: {
					title: __("Temporary Login", "ultimate-security"),
					description:
						"Easily manage temporary logins for secure, time-limited access to your WordPress site. Simplify collaboration while maintaining full control over who can access your store.",
				},
				sub: [
					{
						title: __(
							"Create Temporary Login",
							"ultimate-security",
						),
						url: "/login/temporary-login/create",
					},
					{
						title: __("Settings", "ultimate-security"),
						url: "/login/temporary-login/settings",
					},
					{
						title: __("Express Login", "ultimate-security"),
						url: "/login/temporary-login/express_login",
					},
				],
			},
			{
				title: __("Active Logins", "ultimate-security"),
				url: "/login/active-logins",
				page: {
					title: __("Active Logins", "ultimate-security"),
					description:
						"Easily manage and monitor login sessions for your users with advanced controls to enhance security and prevent unauthorized access.",
				},
				sub: [
					{
						title: __("Settings", "ultimate-security"),
						url: "/login/active-logins/settings",
					},
					{
						title: __("Active Logins", "ultimate-security"),
						url: "/login/active-logins/active_logins",
					},
					{
						title: __("Automations", "ultimate-security"),
						url: "/login/active-logins/automations",
					},
				],
			},
			{
				title: __("Login Security", "ultimate-security"),
				url: "/login/login_security",
				page: {
					title: __("Login Security", "ultimate-security"),
					description:
						"Below you will find a list of advance security options related to login of your WordPress site that reinforces the integrity of your site. All the features add common security implementation and can easily be implemented via easy to understand customization options.",
				},
				sub: [
					{
						title: __("Login Security", "ultimate-security"),
						url: "/login/login_security/login_security",
					},
					{
						title: __("Password Policies", "ultimate-security"),
						url: "/login/login_security/password_policies",
					},
					{
						title: __(
							"Two Factor Authentication",
							"ultimate-security",
						),
						url: "/login/login_security/2fa_authentication",
					},
					{
						title: __("2FA List", "ultimate-security"),
						url: "/login/login_security/2fa_list",
					},
					{
						title: __(
							"Use Administration Password",
							"ultimate-security",
						),
						url: "/login/login_security/use_admin_password",
					},
					{
						title: __("reCAPTCHA", "ultimate-security"),
						url: "/login/login_security/re_captcha",
					},
					{
						title: __("Cloudflare Turnstile", "ultimate-security"),
						url: "/login/login_security/cloudflare_turnstile",
						page: {
							title: "Simple Cloudflare Turnstile",
							description:
								'Easily add the free CAPTCHA service called "Cloudflare Turnstile" to your WordPress forms to help prevent spam.',
						},
					},
					{
					  title: __("Login Limit", "ultimate-security"),
					  url: "/login/login_security/login_limit",
					  page: {
					    title: "Login Limit Settings",
					    description: "Limit the number of login attempts to prevent brute-force attacks and ensure the security of your login process."
					  }
					},
				],
			},
		],
	},

	{
		title: __("Security", "ultimate-security"),
		url: "/security",
		icon: Security,
		page: {
			title: "Security",
			description: "",
		},
		sub: [
			{
				title: __("Salt Changing Behaviour", "ultimate-security"),
				url: "/security/salt_change",
				page: {
					title: __("Salt Changing Behaviour", "ultimate-security"),
					description:
						"WordPress salt keys, or security keys, are essential for safeguarding your website's sensitive data. They strengthen password encryption, making it tougher for hackers to compromise your site. With Ultimate Security for WooCommerce, you don't have to manage these keys yourself—it automatically generates them using the WordPress API, ensuring seamless protection for your site.",
				},
			},
			{
				title: __("Secure Your Data", "ultimate-security"),
				url: "/security/secure-your-data",
				page: {
					title: __("Secure Your Data", "ultimate-security"),
					description:
						"Protect your sensitive information with cutting-edge security measures designed to safeguard your website. Implement robust encryption, prevent unauthorized access, and block potential threats before they arise. Whether it's user data, transaction details, or confidential content, ensure your information remains private, secure, and uncompromised at all times.",
				},
				sub: [
					{
						title: __("Disable Right Click", "ultimate-security"),
						url: "/security/secure-your-data/disable_right_click",
					},
					{
						title: __("Email Blacklist", "ultimate-security"),
						url: "/security/secure-your-data/email_blacklist",
					},
					{
						title: __("Address Blacklist", "ultimate-security"),
						url: "/security/secure-your-data/address_blacklist",
					},
				],
			},
		],
	},

	{
		title: __("Restrictions", "ultimate-security"),
		url: "/restrictions",
		icon: Restrictions,
		page: {
			title: "Restrictions",
			description: "",
		},
		sub: [
			{
				title: __("Settings", "ultimate-security"),
				url: "/restrictions/settings",
				page: {
					title: __("Settings", "ultimate-security"),
					description:
						"Below you will find all the settings you need to restrict specific countires and IP addressses that you wish to restrict for your WooCommerce site. The restrictons will be applied to your WooCommerce pages.",
				},
			},
			{
				title: __("Customize", "ultimate-security"),
				url: "/restrictions/customize",
				page: {
					title: __("Customize", "ultimate-security"),
					description:
						"Below you will find all the settings you need to customize restriction pages including the images that the visitor will see if they are restricted from accessing the website. The customization will be applied to your WooCommerce pages.",
				},
			},
		],
	},
	{
		title: __("More", "ultimate-security"),
		url: "/more",
		icon: More,
		page: {
			title: __("More", "ultimate-security"),
			description: "",
		},
		sub: [
			// {
			//   title: __("Reset", "ultimate-security"),
			//   url: "/more/reset",
			//   page: {
			//     title: __("Reset", "ultimate-security"),
			//     description: "Track and monitor all recent activities related to your plugin. Get detailed insights to help troubleshoot and maintain the performance of your WooCommerce store."
			//   }
			// },
			{
				title: __("Error Notification", "ultimate-security"),
				url: "/more/error-notification",
				page: {
					title: "Error Notification",
					description:
						"Use the following configuration to customize which error notification you would like to receive via your email.",
				},
			},
			{
				title: __("Log", "ultimate-security"),
				url: "/more/log",
				page: {
					title: __("Log", "ultimate-security"),
					description:
						"Track and monitor all recent activities related to your plugin. Get detailed insights to help troubleshoot and maintain the performance of your WooCommerce store.",
				},
				sub: [
					{
						title: __("Status", "ultimate-security"),
						url: "/more/log/status",
					},
				],
			},
			{
				title: __("Misc", "ultimate-security"),
				url: "/more/misc",
				page: {
					title: __("Misc", "ultimate-security"),
					description:
						"Apply a range of miscellaneous security settings to enhance your WooCommerce store's protection. From login security tweaks to advanced access controls, safeguard your online store effortlessly.",
				},
				sub: [
					{
						title: __("API Privacy", "ultimate-security"),
						url: "/more/misc/api_privacy",
					},
					{
						title: __("Recommendations", "ultimate-security"),
						url: "/more/misc/recommendations",
					},
					// {
					//   title: __("Admin Emails", "ultimate-security"),
					//   url: "/more/misc/admin_emails"
					// },
					{
						title: __("Updates", "ultimate-security"),
						url: "/more/misc/updates",
					},
					{
						title: __("Comments", "ultimate-security"),
						url: "/more/misc/comments",
					},
				],
			},
			{
				title: __("Extra", "ultimate-security"),
				url: "/more/extra",
				page: {
					title: "Extra",
					description:
						"These are the extra options for Ultimate Security. Customize them to your requirement.",
				},
			},
		],
	},
	// {
	//   title: __("Subscription & Payments", "ultimate-security"),
	//   url: "#",
	//   icon: Subscriptions,
	//   sub: []
	// }
];
const communityItems = [
	{
		title: __("Feedback", "ultimate-security"),
		url: "https://wordpress.org/support/plugin/ultimate-security/",
		icon: Feedback,
		sub: [],
	},
	{
		title: __("Review", "ultimate-security"),
		url: "https://wordpress.org/support/plugin/ultimate-security/reviews/#new-post",
		icon: Review,
		sub: [],
	},
	{
		title: __("Support Center", "ultimate-security"),
		url: "https://wordpress.org/support/plugin/ultimate-security/",
		icon: SupportCenter,
		sub: [],
	},
	{
		title: __("Other Plugin", "ultimate-security"),
		url: "/other-plugin",
		icon: OtherPlugin,
		sub: [],
	},
];

export const MenuProvider = ({ children }) => {
	const [settingData, setSettingData] = useState({});
	const [settingLoading, setSettingLoading] = useState(true);
	const [reload, setReload] = useState(0);
	const [changeCount, setChangeCount] = useState(false);

	return (
		<MenuContext.Provider
			value={{
				settingData,
				setSettingData,
				reload,
				setReload,
				settingLoading,
				menuData,
				communityItems,
				changeCount,
				setChangeCount,
			}}
		>
			{children}
		</MenuContext.Provider>
	);
};

export const useMenu = () => useContext(MenuContext);
